export const ICONS_ARRAY = ['heart', 'smile', 'fire', 'likes'];
